import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { BookOpen } from "lucide-react";

const FALLBACK_IMG = "https://images.pexels.com/photos/5622211/pexels-photo-5622211.jpeg";
const recipeImg = (image_path) => {
  if (!image_path) return FALLBACK_IMG;
  const token = localStorage.getItem("access_token") || "";
  const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  return `${base}/api/files/${image_path}${token ? `?t=${encodeURIComponent(token)}` : ""}`;
};

export default function PatientRecipes() {
  const [recipes, setRecipes] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/recipes").then(({ data }) => setRecipes(data)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  return (
    <div className="space-y-6" data-testid="patient-recipes-page">
      <header>
        <p className="text-xs uppercase tracking-[0.2em] text-primary font-semibold">Recipes</p>
        <h1 className="text-3xl font-bold mt-1">From your dietitian</h1>
      </header>
      {recipes.length === 0 ? (
        <div className="nt-card p-12 text-center text-muted-foreground" data-testid="no-patient-recipes">
          <BookOpen size={32} className="mx-auto mb-3 text-primary" />
          <p>No recipes available yet.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {recipes.map((r) => (
            <button key={r.recipe_id} onClick={() => setActive(active?.recipe_id === r.recipe_id ? null : r)} className="w-full nt-card text-left overflow-hidden" data-testid={`patient-recipe-${r.recipe_id}`}>
              <div className="flex gap-4 p-4">
                <img src={recipeImg(r.image_path)} alt={r.name} className="w-20 h-20 rounded-lg object-cover" onError={(e) => { e.currentTarget.src = FALLBACK_IMG; }} />
                <div className="flex-1">
                  <div className="font-semibold">{r.name}</div>
                  <div className="text-xs text-muted-foreground mt-1">{r.ingredients?.length || 0} ingredients{r.calories ? ` • ${r.calories} kcal` : ""}</div>
                  {r.notes && <div className="text-sm text-muted-foreground mt-1 line-clamp-2">{r.notes}</div>}
                </div>
              </div>
              {active?.recipe_id === r.recipe_id && (
                <div className="border-t border-border p-4 space-y-3 text-sm">
                  {r.ingredients?.length > 0 && (
                    <div>
                      <div className="font-semibold mb-1">Ingredients</div>
                      <ul className="space-y-0.5 text-muted-foreground">
                        {r.ingredients.map((i, idx) => <li key={idx}>• {i.name} — {i.qty}{i.unit || ""}</li>)}
                      </ul>
                    </div>
                  )}
                  {r.prep_method && (
                    <div>
                      <div className="font-semibold mb-1">Preparation</div>
                      <div className="text-muted-foreground whitespace-pre-line">{r.prep_method}</div>
                    </div>
                  )}
                </div>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
